<template>
  <el-select
    v-model="selectValue"
    filterable
    remote
    :remote-method="getBrandOptions"
    clearable
    :placeholder="$t('common.pleaseInput')"
    v-bind="$attrs"
  >
    <el-option v-for="item in brandOptions" :label="item.label" :value="item.value" :key="item.value" />
  </el-select>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { goodsBrandList } from '@/api/common.js'

const selectValue = defineModel()
onMounted(() => {
  getBrandOptions()
})

const brandOptions = ref([])
const getBrandOptions = async (query) => {
  const params = {
    page: 1,
    size: 100,
    name: query
  }
  const { result } = await goodsBrandList(params)
  if (result) {
    const { data } = result
    brandOptions.value = data.rows.map(item => ({ label: item.name, value: item.id }))
  } else {
    brandOptions.value = []
  }
}

</script>

<style scoped lang="scss">

</style>